"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactAvatarContext = require("./ContactAvatarContext");
Object.keys(_ContactAvatarContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactAvatarContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactAvatarContext[key];
    }
  });
});